module.exports = [{"id":0,"lang":"维护"},{"id":1,"lang":"畅通"},{"id":2,"lang":"火爆"},{"id":3,"lang":"爆满"},{"id":4,"lang":"调试"},{"id":5,"lang":"无限期维护"},{"id":6,"lang":"预备"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/server_load.json
// module id = Zs2K
// module chunks = 1